export default __webpack_public_path__ + "static/media/ab2.7eaab65a.jpeg";